'use client'

import { usePlethoreForm } from '@/contexts/FormContext'
import { DatePicker } from 'antd'
import dayjs from 'dayjs'
import { SBDynamicFormInput } from './types'

const SBDynamicFormInputBirthDate: SBDynamicFormInput = ({ ...rest }) => {
  const { selectedPlan } = usePlethoreForm()

  return (
    <DatePicker
      {...rest}
      style={{ width: '100%' }}
      format={['DD/MM/YYYY']}
      placeholder="DD/MM/YYYY"
      disabledDate={(current) =>
        current &&
        (current.isBefore(
          selectedPlan?.maxAge
            ? dayjs().subtract(selectedPlan?.maxAge, 'year')
            : null,
          'day'
        ) ||
          current.isAfter(
            selectedPlan?.minAge
              ? dayjs().subtract(selectedPlan?.minAge, 'year')
              : null,
            'day'
          ))
      }
    />
  )
}

export { SBDynamicFormInputBirthDate }
